export const numberUtilityMixin = {
  methods: {
    formatWithCommas(value) {
      const num = value || 0;

      return Intl.NumberFormat().format(num);
    },

    formatMoney(value, forStripe = true) {
      // stripe returns full decimal strings with no decimal, ie "1000" = 10.00
      const money = forStripe ? value * 0.01 : value;

      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD"
      }).format(money);
    },

    /**
     * Converts numbers to something easier to read (1,000,000 => 1M).
     * @param {number} value
     * @returns {string}
     */
    shorthandCounter(value) {
      if (value > 999999) {
        return `${(value / 1000000).toFixed(1)}M`;
      }
      if (value > 999999999) {
        return `${(value / 1000000000).toFixed(1)}B`;
      }
      if (value > 999999999999) {
        return `${(value / 1000000000000).toFixed(1)}T`;
      }

      return value;
    },

    sanitizeNum(num) {
      return parseInt(String(num).replace(/\D/, ""), 10);
    }
  }
};
